import { newE2EPage } from "@stencil/core/testing";
import { testValidHtmlElement } from "../../../../test-utils/html-validate";

describe("table-column-custom", () => {
    it.only("should match to snapshot with data", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-custom label="test" field="id"></uic-table-column-custom>
        </uic-table>`);
        await page.find("uic-table-column-custom");
        // eslint-disable-next-line
        await page.$eval("uic-table-column-custom", (elm: any) => {
            elm.cellTemplate = (createElement, row, field) => {
                if (!field || !row[field]) {
                    return null;
                }
                return createElement("a", { href: `/view/${row.id}` }, row[field]);
            };
        });
        const el = await page.find("uic-table");
        el.setProperty("data", [{ id: "1" }, { id: "2" }]);
        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-custom label="test" field="id"></uic-table-column-custom>
        </uic-table>`);
        await page.find("uic-table-column-custom");
        // eslint-disable-next-line
        await page.$eval("uic-table-column-custom", (elm: any) => {
            elm.cellTemplate = (createElement, row, field) => {
                if (!field || !row[field]) {
                    return null;
                }
                return createElement("a", { href: `/view/${row.id}` }, row[field]);
            };
        });
        const el = await page.find("uic-table");
        el.setProperty("data", [{ id: "1" }, { id: "2" }]);
        await page.waitForChanges();
        await testValidHtmlElement(el);
    });
});
